/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of IdP claim mapping evaluation on the user most recent SSO provisioning for a tenant
 * @export
 * @interface IdpProvisioningOutcomeDto
 */
export interface IdpProvisioningOutcomeDto {
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    outcome?: IdpProvisioningOutcomeDtoOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    matchedClaimType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    matchedClaimValue?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    targetType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvisioningOutcomeDto
     */
    targetName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdpProvisioningOutcomeDto
     */
    idpRoles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdpProvisioningOutcomeDto
     */
    idpGroups?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof IdpProvisioningOutcomeDto
     */
    recordedAt?: Date;
}


/**
 * @export
 */
export const IdpProvisioningOutcomeDtoOutcomeEnum = {
    MappingMatchedRole: 'MAPPING_MATCHED_ROLE',
    MappingMatchedGroup: 'MAPPING_MATCHED_GROUP',
    DefaultRoleFallback: 'DEFAULT_ROLE_FALLBACK',
    NoMappingNoDefault: 'NO_MAPPING_NO_DEFAULT',
    NoIdpClaims: 'NO_IDP_CLAIMS'
} as const;
export type IdpProvisioningOutcomeDtoOutcomeEnum = typeof IdpProvisioningOutcomeDtoOutcomeEnum[keyof typeof IdpProvisioningOutcomeDtoOutcomeEnum];


/**
 * Check if a given object implements the IdpProvisioningOutcomeDto interface.
 */
export function instanceOfIdpProvisioningOutcomeDto(value: object): value is IdpProvisioningOutcomeDto {
    return true;
}

export function IdpProvisioningOutcomeDtoFromJSON(json: any): IdpProvisioningOutcomeDto {
    return IdpProvisioningOutcomeDtoFromJSONTyped(json, false);
}

export function IdpProvisioningOutcomeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdpProvisioningOutcomeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'matchedClaimType': json['matched_claim_type'] == null ? undefined : json['matched_claim_type'],
        'matchedClaimValue': json['matched_claim_value'] == null ? undefined : json['matched_claim_value'],
        'targetType': json['target_type'] == null ? undefined : json['target_type'],
        'targetName': json['target_name'] == null ? undefined : json['target_name'],
        'idpRoles': json['idp_roles'] == null ? undefined : json['idp_roles'],
        'idpGroups': json['idp_groups'] == null ? undefined : json['idp_groups'],
        'recordedAt': json['recorded_at'] == null ? undefined : (new Date(json['recorded_at'])),
    };
}

export function IdpProvisioningOutcomeDtoToJSON(json: any): IdpProvisioningOutcomeDto {
    return IdpProvisioningOutcomeDtoToJSONTyped(json, false);
}

export function IdpProvisioningOutcomeDtoToJSONTyped(value?: IdpProvisioningOutcomeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'summary': value['summary'],
        'matched_claim_type': value['matchedClaimType'],
        'matched_claim_value': value['matchedClaimValue'],
        'target_type': value['targetType'],
        'target_name': value['targetName'],
        'idp_roles': value['idpRoles'],
        'idp_groups': value['idpGroups'],
        'recorded_at': value['recordedAt'] == null ? undefined : ((value['recordedAt']).toISOString()),
    };
}

